import { ComponentProps } from "react";

import { cn } from "@/common/utils/css.utils";

type HyperlinkHrefProps = { as?: "href" } & ComponentProps<"a">;
type HyperlinkButtonProps = { as: "button" } & ComponentProps<"button">;
type HyperlinkProps = HyperlinkHrefProps | HyperlinkButtonProps;

export const Hyperlink = ({ className, ...props }: HyperlinkProps) => {
  if (props.as === "button") {
    return (
      <button
        className={cn(
          "cursor-pointer font-body text-base text-brand-500 underline",
          className
        )}
        {...props}
      />
    );
  }

  return (
    <a
      className={cn(
        "cursor-pointer font-body text-base text-brand-500 underline",
        className
      )}
      {...props}
    />
  );
};
